'use strict'

// VU Color Scheme
var teal = (exports.teal = '#007680')

// Yellowish
var grandis = (exports.grandis = '#ffd281')
var yellowOrange = (exports.yellowOrange = '#feb533')

// Purple
var eggplant = (exports.eggplant = '#800080')

// White - Gray
var white = (exports.whiate = '#FFF')
var alabaster = (exports.alabaster = '#f9f9f9')
var gallery = (exports.gallery = '#eee')
var silver = (exports.silver = '#acacac')
var gray = (exports.gray = '#717171')
var tundra = (exports.tundra = '#444')
var mineshaft = (exports.mineshaft = '#262626')

// Blues
var loblollyWcag = (exports.loblollyWcag = '#70777B')
var loblolly = (exports.loblolly = '#b7c3cc')
var cornflower = (exports.cornflower = '#88b8e0')
var lochmara = (exports.lochmara = '#0078c1')
var funblue = (exports.funblue = '#196aac')
var skybluedark = (exports.skybluedark = '#48a2d7')
var bahamablue = (exports.bahamablue = '#00609a')
var cello = (exports.cello = '#1f435d')
var elephant = (exports.elephant = '#123955')
